import { FormAtylBase } from '../../form-atyl-base'

export class AtylTelephone extends FormAtylBase<string> {
	controlType = 'tel'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
